<template>
  <div class="PlusMinusComponent">
    <v-btn
      icon="mdi-minus"
      variant="outlined"
      size="large"
      rounded="0"
      :disabled="decreaseDisabled"
      @click="emit('decrease')"
    />

    <span
      class="value-content"
      size="large"
      variant="outlined"
      rounded="0"
    >
      {{ value }}
    </span>

    <v-btn
      icon="mdi-plus"
      variant="outlined"
      size="large"
      rounded="0"
      :disabled="increaseDisabled"
      @click="emit('increase')"
    />
  </div>
</template>

<script setup lang="ts">
interface PropsInterface {
  value: string
  decreaseDisabled?: boolean
  increaseDisabled?: boolean
}
withDefaults(defineProps<PropsInterface>(), {})

const emit = defineEmits(['increase', 'decrease'])
</script>

<style lang="scss" scoped>
.PlusMinusComponent {
  display: flex;
  gap: $gap-l;
  margin-bottom: $spacing-l;

  .value-content {
    flex: 1;
    display: grid;
    place-items: center;
    border: 1px solid $color-neutral-light;
    color: $color-neutral-dark;
  }
}
</style>
